module.exports = __webpack_public_path__ + "img/product_108.1510a99.webp";